import { render, staticRenderFns } from "./template-manage-activities.vue?vue&type=template&id=c5257542&scoped=true"
import script from "./template-manage-activities.vue?vue&type=script&lang=js"
export * from "./template-manage-activities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5257542",
  null
  
)

export default component.exports